module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-date-preset",
    class: _vm.cssClass
  }, [_c('multiselect', {
    attrs: {
      "placeholder": 'Select a date range',
      "options": _vm.options,
      "track-by": 'key',
      "label": 'label',
      "allow-empty": false,
      "searchable": false,
      "deselect-label": '',
      "value": _vm.selection
    },
    on: {
      "select": _vm.setDateRange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f71f587"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterDatePreset.vue
// module id = 425
// module chunks = 1